peque.navigation = (function () {
  "use strict";

  var $loader;

  var getLoader = function () {
    if ($loader === undefined) {
      $loader = document.querySelector("#global-loader");
    }
    return $loader;
  };

  var showLoader = function () {
    // getLoader().style.display = "block";
  };

  var hideLoader = function () {
    // getLoader().style.display = "none";
  };

  var isLoaderVisible = function () {
    // return getLoader().style.display == "block";
  };

  /**
   * Redirect user to a path without ajax load
   * @param path
   */
  var redirect = function (path) {
    if (path === "home") {
      path = "";
    }
    if (path === "appHome") {
        path = "/app/";
    }
    if (path.substring(0, 1) !== "/") {
      path = "/" + path;
    }

    window.location = path;
  };

  /**
   * Ajax navigation
   * @param path
   */
  var browse = function (path) {
    location.href = path;
    return;
    if (path == "#") {
      return;
    }

    history.pushState({}, path, path);

    peque.navigation.get(path, function (html) {
      $("#main-container").html(html);

      afterLoad();
    });
  };

  var afterLoad = function () {
    // init country selector widgets
    $(".country-selector:not(data-parsed)").each(function () {
      var $that = $(this);

      $that.find(".arrow-container").on("click", function () {
        $that.find(".country-list").toggle();
      });

      $that.find("input").on("click", function () {
        var query = $(this).val().toLowerCase();

        if (query.length < 2) {
          return;
        }

        $that.find("li").each(function () {
          if ($(this).data("name").toLowerCase().indexOf(query) > -1) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      });

      $(this).data("parsed", true);
    });
  };
  /*
												  // must be declared after browser() method
												  $(document).on("click", "a:not([target='_blank'])", function (e)
												  {
													  e.preventDefault();
				
													  browse($(this).attr("href"));
												  });
												  $(function() {
													  afterLoad();
												  });
											  */

  /**
   * Attempts to fix the given error code
   * @param data object
   * @param callback function
   */
  var parseError = function (data, callback) {
    switch (data.error) {
      case peque.ERROR_UPGRADE_PLAN:
        // enable any disabled submit button, so if he pays, he will be able to resume his work
        enableDisabledButtons();
        peque.showLimitReachedModal(
          typeof data.field !== "undefined" ? data.field : ""
        );
        break;
      case peque.ERROR_USER_NOT_LOGGED: // unauthorized request (probably session expired)
        peque.navigation.redirect(
          "logout?redirect=" +
            encodeURIComponent(location.pathname + location.search)
        );
        break;
      case peque.ERROR_NO_ENOUGH_MONEY:
        showError("You can't afford that");
        break;
      case peque.ERROR_NO_ENOUGH_RESOURCES:
        enableDisabledButtons();
        showError("You don't have enough resources");
        break;
      case peque.ERROR_MISSING_PARAMS:
      case peque.ERROR_ACTION_FAILED:
        enableDisabledButtons();
        showError(data.result);
        break;
      case peque.ERROR_TRIAL_EXPIRED:
        // enable any disabled submit button, so if he pays, he will be able to resume his work
        enableDisabledButtons();

        peque.showTrialExpiredModal();
        break;

      case peque.ERROR_NO_ENOUGH_AUTHORIZED_SHARES:
        const [_, vars] = data.result.split(/:(.*)/s).map((s) => s.trim());
        const parsedVars = JSON.parse(vars);
        enableDisabledButtons();
        showError(trans('no_enough_authorized_shares', parsedVars));
        break;

      default:
        callback(data);
        break;
    }
  };

  const enableDisabledButtons = () => {
    document
      .querySelectorAll('button[type="submit"][disabled]')
      .forEach((el) => {
        el.removeAttribute("disabled");
      });
  };

  var post = function (url, params, callback) {
    showLoader();
    $.post(url, params, function (data) {
      hideLoader();

      if (typeof data == "object") {
        parseError(data, callback);
      } else {
        callback(data);
      }
    });
  };

  var get = function (url, params, callback) {
    showLoader();

    // check if this request doesnt need params
    if (typeof params == "function") {
      callback = params;
      params = {};
    }

    $.get(url, params, function (data) {
      hideLoader();

      if (typeof data == "object") {
        parseError(data, callback);
      } else {
        callback(data);
      }
    });
  };

  var showError = function (message) {
    const options = {
      title: "¡Error!",
      icon: "error",
      confirmButtonColor: "#169bd7",
    };

    if (message && message.includes("<")) {
      options.html = message;
    } else if (message) {
      options.text = message;
    } else {
      options.text = trans("unknown_error");
    }

    return Swal.fire(options);
  };

  var showConfirm = function (message, title) {
    const options = {
      title: typeof title === "undefined" ? trans("are_you_sure") : title,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#169bd7",
      confirmButtonText: trans("confirm"),
    };
    if (message && message.includes("<")) {
      options.html = message;
    } else if (message) {
      options.text = message;
    }
    return Swal.fire(options);
  };

  var showSuccess = function (message, ops) {
    if (typeof ops === "undefined") {
      ops = {};
    }

    if (typeof ops.callback === "undefined") {
      return Swal.fire({
        title: trans("success"),
        text: message,
        confirmButtonColor: "#169bd7",
        icon: "success",
      });
    } else {
      return Swal.fire(
        {
          title: trans("success"),
          text: message,
          confirmButtonColor: "#169bd7",
          icon: "success",
        },
        ops.callback
      );
    }
  };

  var reload = function () {
    location.reload();
  };

  var fakePush = function (path) {
    history.pushState({}, path, path);
  };

  const countStakeholders = async () => {
    const $leftSubscriptionContainer = document.getElementById(
      "left-subscription-container"
    );

    const shouldHide = (pathname = window.location.pathname) => {
      const hide =
        pathname.includes("my-equity") || pathname.includes("my-documents");
      if (hide) {
        $leftSubscriptionContainer.classList.add("d-none");
      } else {
        $leftSubscriptionContainer.classList.remove("d-none");
      }
    };

    const company = window.currentCompany;
    if (!company || !$leftSubscriptionContainer) {
      return;
    }

    const currentPlan =
      company.subscription_plan || peque.SUBSCRIPTION_PLAN_FREE;
    const planStakeholdersLimit =
      peque.SUBSCRIPTION_LIMITS[currentPlan].stakeholders;

    if (window["reactLocationChange"]) {
      window["reactLocationChange"].addEventListener("locationChange", (e) => {
        shouldHide(e.detail.location.pathname);
      });
    }

    const $count = $leftSubscriptionContainer.querySelector(
      "[data-stakeholders]"
    );

    const $progress = $leftSubscriptionContainer.querySelector(
        "[data-stakeholders-progress]"
    );

    if (
      $count &&
      company.subscription_plan !== peque.SUBSCRIPTION_PLAN_CUSTOM
    ) {
      const { result: count } = await peque.api(
        "stakeholders/count",
        { company: window.currentCompany.id },
        "get"
      );

      $count.innerText = `${count}/${planStakeholdersLimit}`;

      if ($progress) {
        $progress.style.width = `${(count / planStakeholdersLimit) * 100}%`;
      }
    }
    shouldHide();
  };

  setTimeout(() => {
    countStakeholders();
  }, 2000);

  return {
    reload,
    showLoader,
    hideLoader,
    isLoaderVisible,
    redirect,
    fakePush,
    browse,
    parseError,
    showError,
    showConfirm,
    showSuccess,
    post,
    get,
  };
})();
